import React, { useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Testimonial.css";
import person from "../images/Sri Krishnaa Logo.png";
import p from "../images/Sri Krishnaa Logo.png";
import p0 from "../images/Sri Krishnaa Logo.png";

const Testimonials = () => {
  const scrollContainer = useRef(null);

  const scrollLeft = () => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollContainer.current) {
      scrollContainer.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const testimonials = [
    {
      id: 1,
      name: "Batman",
      image: person,
      experience:
        "I’m vengeance. I’m the night. And I’m also a sucker for these authentic Indian flavors. If Gotham had food like this, I might hang up the cape. Alfred, order more—stat!",
    },
    {
      id: 2,
      name: "Deadpool",
      image: p,
      experience:
        "This food? Maximum flavor. Every bite is like a Bollywood fight scene—colorful, spicy, and leaves you wanting a sequel. If I could marry curry, I would. Call me, naan bread!",
    },
    {
      id: 3,
      name: "John Wick",
      image: p0,
      experience:
        "They took my hunger, and I came for revenge—with this menu. Every dish hit the target. You’ve got my loyalty... and my appetite. Consider this my blood oath.",
    },
    {
      id: 4,
      name: "Iron Man",
      image: person,
      experience:
        "I love you 3,000... and I love this food even more. It’s like Jarvis cooked it himself. No need for a suit to enjoy these flavors—though I’d upgrade for unlimited refills.",
    },
    {
      id: 5,
      name: "Spiderman",
      image: p,
      experience:
        "With great flavor comes great responsibility... to order more. This food stuck to my heart faster than my webs. Aunt May, we’re eating out every night from now on!",
    },
    {
      id: 6,
      name: "Hulk",
      image: p0,
      experience:
        "Hulk hungry. Hulk eat. Hulk happy. Smashingly good food—so good even Banner couldn’t calm me down. Warning: May cause uncontrollable cravings.",
    },
    {
      id: 7,
      name: "Thor",
      image: person,
      experience:
        "Is this food forged in the heart of a dying star? The flavors struck like thunder and the spice hit harder than Mjölnir. By Odin’s beard, I shall return for more!",
    },
  ];

  return (
    <div className="testimonials-section">
      <button className="testimonials-scroll-button testimonials-left" onClick={scrollLeft}>
        ‹
      </button>

      <div className="testimonials-scroll-container">
        <div className="testimonials-scroll" ref={scrollContainer}>
          {testimonials.map((item) => (
            <div className="testimonials-card" key={item.id}>
              <img src={item.image} alt={item.name} className="testimonials-image" />
              <h3 className="testimonials-name">{item.name}</h3>
              <p className="testimonials-experience">"{item.experience}"</p>
            </div>
          ))}
        </div>
      </div>

      <button className="testimonials-scroll-button testimonials-right" onClick={scrollRight}>
        ›
      </button>
    </div>
  );
};

export default Testimonials;
